import React from "react"
import styled from "styled-components"

export default function L({ rotate, type }) {
  return (
    <Wrapper
      className={type && "question"}
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      <div />
      <div />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  max-width: 50px;
  max-height: 50px;
  height: 100%;
  position: relative;
  > div {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    padding-bottom: 20%;
    background-color: #00fff0;
    border-radius: 0 0 100px 0;
    &:nth-child(2) {
      top: 0;
      left: 0;
      padding-bottom: 100%;
      width: 20%;
    }
  }
  &.question {
    max-width: 30px;
    max-height: 30px;
  }
  @media (max-width: 768px) {
    max-width: 30px;
    max-height: 30px;
  }
`
